<template>
  <v-layout fill-height column id="tutorialGuide02">
    <v-main class="page-main tutorial-guide-content" :style="{'background-image' : `url(${getImage(background)})`}">
      <v-container fluid class="flex-fill" style="width: auto;">
        <div class="main-top">
          <v-btn icon :ripple="false"
                 class="btn-notice new"
                 @click.prevent />
          <!-- 삼성 화재용 로고 -->
          <div v-if="isSamsungFire" class="customer-logo" @click.prevent>
            <img :src="getImage('logo_anyfit.png')"/>
          </div>
          <!-- 삼성 화재용 로고 -->
        </div>
        <div class="greetings">
          <!-- 기본 박스 사이즈 잡아주는 부분 -->
          <div class="greetings-hidden">오늘 하루는 어떤 하루로<br/>남기고 싶나요?</div>
        </div>
        <div class="my-travel-status">
          <button type="button" class="v-btn v-btn--text theme--light v-size--default">
            <span class="v-btn__content">현재 1일째 여행중입니다. </span>
          </button>
          <br></div>
      </v-container>
      <slot name="bottomMenu" />
    </v-main>
    <slot />
  </v-layout>
</template>

<script>
import {mixinAuth} from '@/mixins'
export default {
  name: 'TutorialSlide2',
  components: {},
  mixins: [mixinAuth],
  props: ['props'],
  data: () => ({}),
  computed: {
    background () {
      return this.props.background
    }
  }
}
</script>
